export const getMenuItemsAll = () => {
  // Items do menu ação
  return [{ key: "3", label: "Converter Proprietários" }];
};
